import { USER_ROLES_NAME } from '@/constants/auth.constants';
import { UserRoleEnum } from '@/types/auth.types';

import { AccountStatusEnum } from '../types';

const ACCOUNT_STATUS_CONTENTS = {
  [AccountStatusEnum['during-an-invitation']]: {
    text: '招待中',
    status: 'warning',
  },
  [AccountStatusEnum['registration-complete']]: {
    text: 'アクティブ',
    status: 'success',
  },
  [AccountStatusEnum['invitation-expired']]: {
    text: '期限切れ',
    status: 'default',
  },
} as const;

const ACCOUNT_ROLE_OPTIONS = [
  { value: UserRoleEnum.organization, label: USER_ROLES_NAME.organization },
  { value: UserRoleEnum.wedding, label: USER_ROLES_NAME.wedding },
];

export { ACCOUNT_ROLE_OPTIONS, ACCOUNT_STATUS_CONTENTS };
